/**
 * Get color for severity level (for alerts)
 */
export const getSeverityColor = (severity) => {
    switch (severity) {
        case 'high': return '#f44336';    // Red
        case 'medium': return '#ff9800';  // Orange
        case 'low': return '#9e9e9e';     // Gray
        default: return '#1976d2';        // Blue
    }
}


  